import * as types from "../types/index";
import { core } from "./core";

export const getOnboardingSteps = (data) => {
  return core.API(
    "GET",
    `/onboarding`,
    types.GET_ONBOARDING_STEPS,
    types.GET_ONBOARDING_STEPS_SUCCESS,
    types.GET_ONBOARDING_STEPS_FAILURE,
    data
  );
};

export const putOnboardingSteps = (data) => {
  return core.API(
    "PUT",
    `/onboarding`,
    types.PUT_ONBOARDING_STEPS,
    types.PUT_ONBOARDING_STEPS_SUCCESS,
    types.PUT_ONBOARDING_STEPS_FAILURE,
    data
  );
};

export const importData = (data) => {
  return core.API(
    "POST",
    `/onboarding/import`,
    types.IMPORT_DATA,
    types.IMPORT_DATA_SUCCESS,
    types.IMPORT_DATA_FAILURE,
    data
  );
};

export const showHideDemoData = (data) => {
  return core.API(
    "PUT",
    `/onboarding/hide-show`,
    types.SHOW_HIDE_DEMO_DATA,
    types.SHOW_HIDE_DEMO_DATA_SUCCESS,
    types.SHOW_HIDE_DEMO_DATA_FAILURE,
    data
  );
};

//
export const attachFile = (data) => {
  return core.API(
    "PUT",
    `/onboarding/attach-file`,
    types.ATTACH_FILE,
    types.ATTACH_FILE_SUCCESS,
    types.ATTACH_FILE_FAILURE,
    data
  );
};

export const uploadOnboardingFile = (data) => {
  return core.API(
    "PUT",
    `/onboarding/upload-file`,
    types.UPLOAD_ONBOARDING_FILE,
    types.UPLOAD_ONBOARDING_FILE_SUCCESS,
    types.UPLOAD_ONBOARDING_FILE_FAILURE,
    data
  );
};

export const importOnboardingRecords = (data) => {
  return core.API(
    "PUT",
    `/onboarding/import-file`,
    types.IMPORT_ONBOARDING_DATA,
    types.IMPORT_ONBOARDING_DATA_SUCCESS,
    types.IMPORT_ONBOARDING_DATA_FAILURE,
    data
  );
};
